import React, { useEffect, useRef, useState } from 'react';
import { Loading } from '@fourthwall/components';
import { IframeModal } from './IframeModal';
export const SettingsIframe = ({ hmac, shopId, openModal, settingsUrl, name, }) => {
    const iframeRef = useRef(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [iframeHeight, setIframeHeight] = useState(400);
    useEffect(() => {
        const handleMessage = (event) => {
            // Verify the origin for security
            if (event.source !== iframeRef.current?.contentWindow) {
                return;
            }
            const allowedOrigin = new URL(settingsUrl).origin;
            if (event.origin !== allowedOrigin) {
                console.error(`Received message from unauthorized origin: ${event.origin}`);
                return;
            }
            try {
                const { type, data } = event.data;
                switch (type) {
                    case 'CLIPBOARD':
                        navigator.clipboard.writeText(data.text);
                        break;
                    case 'SET_HEIGHT':
                        // Handle resize
                        setIframeHeight(data.height);
                        break;
                    case 'MODAL':
                        if (!data.path) {
                            console.error('No path provided');
                            return;
                        }
                        // Open modal with data from iframe - following established pattern
                        openModal(IframeModal, {
                            title: data.title || `Message from ${name}`,
                            src: `${settingsUrl}${data.path}`,
                            hmac,
                            shopId,
                            onRefresh: () => {
                                if (iframeRef.current) {
                                    iframeRef.current.src = iframeRef.current.src;
                                }
                            },
                        });
                        break;
                    default:
                        console.error(`Received unknown message type: ${type}`, data);
                }
            }
            catch (error) {
                console.error('Error processing postMessage:', error);
            }
        };
        // Add event listener
        window.addEventListener('message', handleMessage);
        // Cleanup function
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [openModal, hmac, shopId, settingsUrl]);
    return (React.createElement(React.Fragment, null,
        !isLoaded && React.createElement(Loading, { isLoading: true }),
        React.createElement("iframe", { ref: iframeRef, style: {
                display: isLoaded ? 'block' : 'none',
                marginTop: '50px',
                height: iframeHeight + 40,
                border: 'none',
                overflowY: 'hidden',
            }, src: `${settingsUrl}?hmac=${encodeURIComponent(hmac.signature)}&timestamp=${encodeURIComponent(hmac.timestamp)}&shop_id=${encodeURIComponent(shopId)}`, onLoad: () => setIsLoaded(true), width: "100%" })));
};
